import {ToastHandlerState} from '../reducers/toast-handler'

export const getToast = (state: ToastHandlerState) => state.toast
